webpackJsonp([195254786234044],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(53);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * random-seed
	 * https://github.com/skratchdot/random-seed
	 *
	 * This code was originally written by Steve Gibson and can be found here:
	 *
	 * https://www.grc.com/otg/uheprng.htm
	 *
	 * It was slightly modified for use in node, to pass jshint, and a few additional
	 * helper functions were added.
	 *
	 * Copyright (c) 2013 skratchdot
	 * Dual Licensed under the MIT license and the original GRC copyright/license
	 * included below.
	 */
	/*	============================================================================
										Gibson Research Corporation
					UHEPRNG - Ultra High Entropy Pseudo-Random Number Generator
		============================================================================
		LICENSE AND COPYRIGHT:  THIS CODE IS HEREBY RELEASED INTO THE PUBLIC DOMAIN
		Gibson Research Corporation releases and disclaims ALL RIGHTS AND TITLE IN
		THIS CODE OR ANY DERIVATIVES. Anyone may be freely use it for any purpose.
		============================================================================
		This is GRC's cryptographically strong PRNG (pseudo-random number generator)
		for JavaScript. It is driven by 1536 bits of entropy, stored in an array of
		48, 32-bit JavaScript variables.  Since many applications of this generator,
		including ours with the "Off The Grid" Latin Square generator, may require
		the deteriministic re-generation of a sequence of PRNs, this PRNG's initial
		entropic state can be read and written as a static whole, and incrementally
		evolved by pouring new source entropy into the generator's internal state.
		----------------------------------------------------------------------------
		ENDLESS THANKS are due Johannes Baagoe for his careful development of highly
		robust JavaScript implementations of JS PRNGs.  This work was based upon his
		JavaScript "Alea" PRNG which is based upon the extremely robust Multiply-
		With-Carry (MWC) PRNG invented by George Marsaglia. MWC Algorithm References:
		http://www.GRC.com/otg/Marsaglia_PRNGs.pdf
		http://www.GRC.com/otg/Marsaglia_MWC_Generators.pdf
		----------------------------------------------------------------------------
		The quality of this algorithm's pseudo-random numbers have been verified by
		multiple independent researchers. It handily passes the fermilab.ch tests as
		well as the "diehard" and "dieharder" test suites.  For individuals wishing
		to further verify the quality of this algorithm's pseudo-random numbers, a
		256-megabyte file of this algorithm's output may be downloaded from GRC.com,
		and a Microsoft Windows scripting host (WSH) version of this algorithm may be
		downloaded and run from the Windows command prompt to generate unique files
		of any size:
		The Fermilab "ENT" tests: http://fourmilab.ch/random/
		The 256-megabyte sample PRN file at GRC: https://www.GRC.com/otg/uheprng.bin
		The Windows scripting host version: https://www.GRC.com/otg/wsh-uheprng.js
		----------------------------------------------------------------------------
		Qualifying MWC multipliers are: 187884, 686118, 898134, 1104375, 1250205,
		1460910 and 1768863. (We use the largest one that's < 2^21)
		============================================================================ */
	'use strict';
	var stringify = __webpack_require__(39);
	
	/*	============================================================================
	This is based upon Johannes Baagoe's carefully designed and efficient hash
	function for use with JavaScript.  It has a proven "avalanche" effect such
	that every bit of the input affects every bit of the output 50% of the time,
	which is good.	See: http://baagoe.com/en/RandomMusings/hash/avalanche.xhtml
	============================================================================
	*/
	var Mash = function () {
		var n = 0xefc8249d;
		var mash = function (data) {
			if (data) {
				data = data.toString();
				for (var i = 0; i < data.length; i++) {
					n += data.charCodeAt(i);
					var h = 0.02519603282416938 * n;
					n = h >>> 0;
					h -= n;
					h *= n;
					n = h >>> 0;
					h -= n;
					n += h * 0x100000000; // 2^32
				}
				return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
			} else {
				n = 0xefc8249d;
			}
		};
		return mash;
	};
	
	var uheprng = function (seed) {
		return (function () {
			var o = 48; // set the 'order' number of ENTROPY-holding 32-bit values
			var c = 1; // init the 'carry' used by the multiply-with-carry (MWC) algorithm
			var p = o; // init the 'phase' (max-1) of the intermediate variable pointer
			var s = new Array(o); // declare our intermediate variables array
			var i; // general purpose local
			var j; // general purpose local
			var k = 0; // general purpose local
	
			// when our "uheprng" is initially invoked our PRNG state is initialized from the
			// browser's own local PRNG. This is okay since although its generator might not
			// be wonderful, it's useful for establishing large startup entropy for our usage.
			var mash = new Mash(); // get a pointer to our high-performance "Mash" hash
	
			// fill the array with initial mash hash values
			for (i = 0; i < o; i++) {
				s[i] = mash(Math.random());
			}
	
			// this PRIVATE (internal access only) function is the heart of the multiply-with-carry
			// (MWC) PRNG algorithm. When called it returns a pseudo-random number in the form of a
			// 32-bit JavaScript fraction (0.0 to <1.0) it is a PRIVATE function used by the default
			// [0-1] return function, and by the random 'string(n)' function which returns 'n'
			// characters from 33 to 126.
			var rawprng = function () {
				if (++p >= o) {
					p = 0;
				}
				var t = 1768863 * s[p] + c * 2.3283064365386963e-10; // 2^-32
				return s[p] = t - (c = t | 0);
			};
	
			// this EXPORTED function is the default function returned by this library.
			// The values returned are integers in the range from 0 to range-1. We first
			// obtain two 32-bit fractions (from rawprng) to synthesize a single high
			// resolution 53-bit prng (0 to <1), then we multiply this by the caller's
			// "range" param and take the "floor" to return a equally probable integer.
			var random = function (range) {
				return Math.floor(range * (rawprng() + (rawprng() * 0x200000 | 0) * 1.1102230246251565e-16)); // 2^-53
			};
	
			// this EXPORTED function 'string(n)' returns a pseudo-random string of
			// 'n' printable characters ranging from chr(33) to chr(126) inclusive.
			random.string = function (count) {
				var i;
				var s = '';
				for (i = 0; i < count; i++) {
					s += String.fromCharCode(33 + random(94));
				}
				return s;
			};
	
			// this PRIVATE "hash" function is used to evolve the generator's internal
			// entropy state. It is also called by the EXPORTED addEntropy() function
			// which is used to pour entropy into the PRNG.
			var hash = function () {
				var args = Array.prototype.slice.call(arguments);
				for (i = 0; i < args.length; i++) {
					for (j = 0; j < o; j++) {
						s[j] -= mash(args[i]);
						if (s[j] < 0) {
							s[j] += 1;
						}
					}
				}
			};
	
			// this EXPORTED "clean string" function removes leading and trailing spaces and non-printing
			// control characters, including any embedded carriage-return (CR) and line-feed (LF) characters,
			// from any string it is handed. this is also used by the 'hashstring' function (below) to help
			// users always obtain the same EFFECTIVE uheprng seeding key.
			random.cleanString = function (inStr) {
				inStr = inStr.replace(/(^\s*)|(\s*$)/gi, ''); // remove any/all leading spaces
				inStr = inStr.replace(/[\x00-\x1F]/gi, ''); // remove any/all control characters
				inStr = inStr.replace(/\n /, '\n'); // remove any/all trailing spaces
				return inStr; // return the cleaned up result
			};
	
			// this EXPORTED "hash string" function hashes the provided character string after first removing
			// any leading or trailing spaces and ignoring any embedded carriage returns (CR) or Line Feeds (LF)
			random.hashString = function (inStr) {
				inStr = random.cleanString(inStr);
				mash(inStr); // use the string to evolve the 'mash' state
				for (i = 0; i < inStr.length; i++) { // scan through the characters in our string
					k = inStr.charCodeAt(i); // get the character code at the location
					for (j = 0; j < o; j++) { //	"mash" it into the UHEPRNG state
						s[j] -= mash(k);
						if (s[j] < 0) {
							s[j] += 1;
						}
					}
				}
			};
	
			// this EXPORTED function allows you to seed the random generator.
			random.seed = function (seed) {
				if (typeof seed === 'undefined' || seed === null) {
					seed = Math.random();
				}
				if (typeof seed !== 'string') {
					seed = stringify(seed, function (key, value) {
						if (typeof value === 'function') {
							return (value).toString();
						}
						return value;
					});
				}
				random.initState();
				random.hashString(seed);
			};
	
			// this handy exported function is used to add entropy to our uheprng at any time
			random.addEntropy = function ( /* accept zero or more arguments */ ) {
				var args = [];
				for (i = 0; i < arguments.length; i++) {
					args.push(arguments[i]);
				}
				hash((k++) + (new Date().getTime()) + args.join('') + Math.random());
			};
	
			// if we want to provide a deterministic startup context for our PRNG,
			// but without directly setting the internal state variables, this allows
			// us to initialize the mash hash and PRNG's internal state before providing
			// some hashing input
			random.initState = function () {
				mash(); // pass a null arg to force mash hash to init
				for (i = 0; i < o; i++) {
					s[i] = mash(' '); // fill the array with initial mash hash values
				}
				c = 1; // init our multiply-with-carry carry
				p = o; // init our phase
			};
	
			// we use this (optional) exported function to signal the JavaScript interpreter
			// that we're finished using the "Mash" hash function so that it can free up the
			// local "instance variables" is will have been maintaining.  It's not strictly
			// necessary, of course, but it's good JavaScript citizenship.
			random.done = function () {
				mash = null;
			};
	
			// if we called "uheprng" with a seed value, then execute random.seed() before returning
			if (typeof seed !== 'undefined') {
				random.seed(seed);
			}
	
			// Returns a random integer between 0 (inclusive) and range (exclusive)
			random.range = function (range) {
				return random(range);
			};
	
			// Returns a random float between 0 (inclusive) and 1 (exclusive)
			random.random = function () {
				return random(Number.MAX_VALUE - 1) / Number.MAX_VALUE;
			};
	
			// Returns a random float between min (inclusive) and max (exclusive)
			random.floatBetween = function (min, max) {
				return random.random() * (max - min) + min;
			};
	
			// Returns a random integer between min (inclusive) and max (inclusive)
			random.intBetween = function (min, max) {
				return Math.floor(random.random() * (max - min + 1)) + min;
			};
	
			// when our main outer "uheprng" function is called, after setting up our
			// initial variables and entropic state, we return an "instance pointer"
			// to the internal anonymous function which can then be used to access
			// the uheprng's various exported functions.  As with the ".done" function
			// above, we should set the returned value to 'null' once we're finished
			// using any of these functions.
			return random;
		}());
	};
	
	// Modification for use in node:
	uheprng.create = function (seed) {
		return new uheprng(seed);
	};
	module.exports = uheprng;


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(12);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _puzzle = __webpack_require__(32);
	
	var _puzzle2 = _interopRequireDefault(_puzzle);
	
	var _Grid = __webpack_require__(30);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Game = function (_React$Component) {
	  _inherits(Game, _React$Component);
	
	  function Game(props) {
	    _classCallCheck(this, Game);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var seed = props.seed,
	        gridSize = props.gridSize,
	        colourCount = props.colourCount,
	        remove = props.remove;
	
	    _puzzle2.default.setSeed(seed);
	    var puzzleState = _puzzle2.default.generatePuzzle(gridSize, colourCount, remove);
	    console.log(puzzleState);
	    _this.state = { puzzleState: puzzleState, moveCount: 0, complete: false };
	    return _this;
	  }
	
	  Game.prototype.render = function render() {
	    var title = this.props.title;
	    var _state = this.state,
	        moveCount = _state.moveCount,
	        complete = _state.complete;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'game-container ' + (complete ? "complete" : "") },
	      _react2.default.createElement(
	        'h3',
	        null,
	        complete ? "Complete!" : title,
	        ' '
	      ),
	      _react2.default.createElement(_Grid2.default, { gameState: this.state.puzzleState, onClick: this.updatePuzzle }),
	      _react2.default.createElement(
	        'p',
	        null,
	        moveCount,
	        ' move',
	        moveCount === 1 ? "" : "s",
	        ' ',
	        moveCount > 0 && _react2.default.createElement(
	          'a',
	          { onClick: this.resetPuzzle },
	          'Reset'
	        )
	      )
	    );
	  };
	
	  return Game;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.resetPuzzle = function () {
	    var gridSize = _this2.props.gridSize;
	
	    for (var i = 1; i <= gridSize; i++) {
	      for (var j = 1; j <= gridSize; j++) {
	        if (_this2.state.puzzleState.rows[i][j].colour != -1) _this2.state.puzzleState.rows[i][j].colour = 0;
	      }
	    }
	    _this2.setState({ puzzleState: _this2.state.puzzleState, moveCount: 0, complete: false });
	  };
	
	  this.updatePuzzle = function (item) {
	    if (!_this2.state.complete) {
	      var _props = _this2.props,
	          gridSize = _props.gridSize,
	          colourCount = _props.colourCount;
	
	
	      var current = _this2.state.puzzleState.rows[item.y][item.x].colour;
	      current++;
	      if (current > colourCount) {
	        current = 0;
	      }
	      _this2.state.puzzleState.rows[item.y][item.x].colour = current;
	      _this2.setState({ puzzleState: _this2.state.puzzleState, moveCount: _this2.state.moveCount + 1 });
	
	      if (_puzzle2.default.isSolution(_this2.state.puzzleState, gridSize, colourCount)) {
	        _this2.completePuzzle();
	      }
	    }
	  };
	
	  this.completePuzzle = function () {
	    return _this2.setState({ complete: true });
	  };
	};
	
	exports.default = Game;
	module.exports = exports['default'];

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GridItem = __webpack_require__(31);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _createReactClass = __webpack_require__(12);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReactClass2.default)({
	    renderRows: function renderRows(delta) {
	        return this.props.gameState.rows.map(this.renderRow(delta));
	    },
	    renderRow: function renderRow(delta) {
	        var _this = this;
	
	        return function (r, i) {
	            return _react2.default.createElement(
	                'g',
	                { style: styles.row, key: i },
	                r.map(function (item, j) {
	                    return _react2.default.createElement(_GridItem2.default, { item: item,
	                        key: j,
	                        delta: delta,
	                        x: j,
	                        y: i,
	                        onClick: function onClick() {
	                            return _this.props.onClick(item);
	                        } });
	                })
	            );
	        };
	    },
	    render: function render() {
	        var n = this.props.gameState.rows.length;
	        var delta = 100.0 / n;
	
	        return _react2.default.createElement(
	            'svg',
	            { viewBox: '0 0 100 100' },
	            this.renderRows(delta)
	        );
	    }
	});
	
	
	var styles = {
	    grid: {
	        flexDirection: "column",
	        justifyContent: "center"
	    },
	    row: {
	        flexDirection: "row",
	        justifyContent: "center"
	
	    }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(12);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReactClass2.default)({
	    backgroundColour: function backgroundColour(colour) {
	        switch (colour) {
	            case -1:
	                return "rgba(0,0,0,0)";
	            case 0:
	                return "#e9e9e9";
	            case 1:
	                return "#D0021B";
	            case 2:
	                return "#7ED321";
	            case 3:
	                return "#4A90E2";
	            case 4:
	                return "#F5A623";
	            case 5:
	                return "#F8E71C";
	            case 6:
	                return "#BD10E0";
	        }
	    },
	    render: function render() {
	        var _props = this.props,
	            x = _props.x,
	            y = _props.y,
	            delta = _props.delta;
	
	        var margin = delta / 12;
	
	        if (this.props.item.interactive) {
	            return _react2.default.createElement('rect', { fill: this.backgroundColour(this.props.item.colour),
	                onClick: this.props.onClick,
	                x: x * delta + margin,
	                y: y * delta + margin,
	                height: delta - 2 * margin,
	                width: delta - 2 * margin,
	                rx: 1,
	                ry: 1
	            });
	        } else {
	            return _react2.default.createElement('rect', { fill: this.backgroundColour(this.props.item.colour),
	                x: x * delta + margin,
	                y: y * delta + margin,
	                height: delta - 2 * margin,
	                width: delta - 2 * margin,
	                rx: 1,
	                ry: 1,
	                opacity: 0.5 });
	        }
	    }
	});
	module.exports = exports['default'];

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _randomSeed = __webpack_require__(40);
	
	var rs = _interopRequireWildcard(_randomSeed);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var rand = rs.create();
	var randomInt = function randomInt(n) {
	    return rand.intBetween(0, n - 1);
	};
	var pickRandom = function pickRandom(choices) {
	    return choices[rand.intBetween(0, choices.length - 1)];
	};
	
	var rangeN = function rangeN(n) {
	    var vals = [];
	    for (var i = 0; i < n; i++) {
	        vals.push(i);
	    }
	    return vals;
	};
	
	var counterN = function counterN(n) {
	    var counter = [];
	    for (var i = 0; i < n; i++) {
	        counter.push(0);
	    }
	    return counter;
	};
	
	var remaining = function remaining(listOfRemovalLists, n) {
	    var start = rangeN(n);
	    for (var _iterator = listOfRemovalLists, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	        } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	        }
	
	        var list = _ref;
	
	        for (var _iterator2 = list, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	            }
	
	            var el = _ref2;
	
	            var idx = start.indexOf(el);
	            if (idx != -1) {
	                start.splice(idx, 1);
	            }
	        }
	    }
	    return start;
	};
	
	var generateRow = function generateRow(existingRows, n) {
	    /*
	    Work along row, generating each square in turn
	     */
	    var newRow = [];
	    for (var i = 0; i < n; i++) {
	
	        var inCol = [];
	        for (var j = 0; j < existingRows.length; j++) {
	            inCol.push(existingRows[j][i]);
	        }
	        var available = remaining([newRow, inCol], n);
	
	        if (available.length > 0) {
	            newRow.push(pickRandom(available));
	        } else {
	            return null;
	        }
	    }
	    return newRow;
	};
	
	var generateLatinSquare = function generateLatinSquare(n) {
	    var rows = [];
	    var count = 0; //probably being paranoid but I'd have to actually do more Maths to figure out if necessary
	    for (var i = 0; i < n; i++) {
	        var newRow = void 0;
	        while (!newRow && count < 100) {
	            newRow = generateRow(rows, n);
	            count++;
	        }
	
	        if (!!newRow) {
	            rows.push(newRow);
	        } else {
	            i--; //ha! this awful but as first row should always be generated fine should be okay
	        }
	    }
	    return rows;
	};
	
	var deepCopy = function deepCopy(obj) {
	    return JSON.parse(JSON.stringify(obj));
	};
	
	var removeClue = function removeClue(puzzle, n) {
	    var newPuzzle = deepCopy(puzzle);
	    var removeId = randomInt(n * 4);
	    if (removeId < n) {
	        newPuzzle.rows[0][removeId].colour = -1;
	        newPuzzle.rows[0][removeId].answer = -1;
	    } else if (removeId < 2 * n) {
	        newPuzzle.rows[n + 1][removeId - n].colour = -1;
	        newPuzzle.rows[n + 1][removeId - n].answer = -1;
	    } else if (removeId < 3 * n) {
	        newPuzzle.rows[removeId - 2 * n][0].colour = -1;
	        newPuzzle.rows[removeId - 2 * n][0].answer = -1;
	    } else {
	        newPuzzle.rows[removeId - 3 * n][n + 1].colour = -1;
	        newPuzzle.rows[removeId - 3 * n][n + 1].answer = -1;
	    }
	    return newPuzzle;
	};
	
	var generatePuzzleWithDifficulty = function generatePuzzleWithDifficulty(n, m, d) {
	    var ls = generateLatinSquare(n);
	    var count = n + 2;
	
	    var startIdx = 0;
	    var endIdx = count - 1;
	
	    var genItem = function genItem(i, j) {
	        var colour = void 0;
	        if (ls[i - 1][j - 1] < m) {
	            colour = ls[i - 1][j - 1] + 1;
	        } else {
	            colour = 0;
	        }
	
	        return {
	            x: j,
	            y: i,
	            interactive: true,
	            colour: 0,
	            answer: colour
	        };
	    };
	
	    var genClue = function genClue(i, j) {
	        var colour = void 0;
	        if (j == startIdx) {
	            var row = ls[i - 1];
	            for (var k = 0; k < row.length; k++) {
	                if (row[k] < m) {
	                    colour = row[k] + 1;
	                    break;
	                }
	            }
	        } else if (j == endIdx) {
	            var _row = ls[i - 1];
	            for (var _k = _row.length - 1; _k > 0; _k--) {
	                if (_row[_k] < m) {
	                    colour = _row[_k] + 1;
	                    break;
	                }
	            }
	        } else if (i == startIdx) {
	            for (var _k2 = 0; _k2 < n; _k2++) {
	                if (ls[_k2][j - 1] < m) {
	                    colour = ls[_k2][j - 1] + 1;
	                    break;
	                }
	            }
	        } else if (i == endIdx) {
	            for (var _k3 = n - 1; _k3 > 0; _k3--) {
	                if (ls[_k3][j - 1] < m) {
	                    colour = ls[_k3][j - 1] + 1;
	                    break;
	                }
	            }
	        }
	        return {
	            x: j,
	            y: i,
	            interactive: false,
	            colour: colour,
	            answer: colour
	        };
	    };
	
	    var genEmpty = function genEmpty(i, j) {
	        return { x: j, y: i, interactive: false, colour: -1, answer: -1 };
	    };
	
	    var rows = [];
	    for (var i = 0; i < count; i++) {
	        var row = [];
	        for (var j = 0; j < count; j++) {
	            if (i == startIdx && j == startIdx || i == endIdx && j == startIdx || j == endIdx && i == endIdx || j == endIdx && i == startIdx) {
	                row.push(genEmpty(i, j));
	            } else if (i == startIdx || i == endIdx || j == startIdx || j == endIdx) {
	                row.push(genClue(i, j));
	            } else {
	                row.push(genItem(i, j));
	            }
	        }
	        rows.push(row);
	    }
	
	    var puzzle = { rows: rows };
	    for (var _i3 = 0; _i3 < d; _i3++) {
	        puzzle = removeClue(puzzle, n);
	    }
	
	    console.log(puzzle.rows);
	
	    //Make 6x6+ puzzles actually interesting (hopefully!)
	    if (n >= 6) {
	        for (var _i4 = 2; _i4 < n; _i4++) {
	            for (var _j = 2; _j < n; _j++) {
	                if (puzzle.rows[_i4][_j].answer == 0) {
	                    puzzle.rows[_i4][_j].interactive = false;
	                    puzzle.rows[_i4][_j].colour = -1;
	                    puzzle.rows[_i4][_j].answer = -1;
	                }
	            }
	        }
	    }
	
	    console.log(puzzle.rows);
	
	    return puzzle;
	};
	
	var isSolution = function isSolution(puzzle, n, m) {
	    //console.log("Is solution?", puzzle);
	    //1. easy check (one of each in row and columns):
	    var isRowValid = function isRowValid(i) {
	        var counter = counterN(m + 1);
	        for (var j = 1; j < n + 1; j++) {
	            counter[puzzle.rows[i][j].colour] += 1;
	        }
	        for (var a = 1; a <= m; a++) {
	            if (counter[a] != 1) return false;
	        }
	        return true;
	    };
	
	    var isColValid = function isColValid(j) {
	        var counter = counterN(m + 1);
	        for (var i = 1; i < n + 1; i++) {
	            counter[puzzle.rows[i][j].colour] += 1;
	        }
	        for (var a = 1; a <= m; a++) {
	            if (counter[a] != 1) return false;
	        }
	        return true;
	    };
	
	    for (var r = 1; r < n + 1; r++) {
	        if (!isRowValid(r)) {
	            return false;
	        }
	    }
	    for (var c = 1; c < n + 1; c++) {
	        if (!isColValid(c)) {
	            return false;
	        }
	    }
	    //2. now clues:
	
	    for (var cid = 0; cid < 4 * n; cid++) {
	        if (cid < n) {
	            var i = cid;
	            if (puzzle.rows[i][0].colour != -1) for (var j = 1; j <= n; j++) {
	                var _c = puzzle.rows[i][j].colour;
	                if (_c > 0) {
	                    if (_c != puzzle.rows[i][0].colour) return false; //look for first colour in row,
	                    break; //otherwise break out of this loop
	                }
	            }
	        } else if (cid < 2 * n) {
	            var _i5 = cid - n;
	            if (puzzle.rows[_i5][n + 1].colour != -1) for (var _j2 = n; _j2 >= 1; _j2--) {
	                var _c2 = puzzle.rows[_i5][_j2].colour;
	                if (_c2 > 0) {
	                    if (_c2 != puzzle.rows[_i5][n + 1].colour) return false; //look for first colour in row (backwards),
	                    break; //otherwise break out of this loop
	                }
	            }
	        } else if (cid < 3 * n) {
	            var _j3 = cid - 2 * n;
	            if (puzzle.rows[0][_j3].colour != -1) for (var _i6 = 1; _i6 <= n; _i6++) {
	                var _c3 = puzzle.rows[_i6][_j3].colour;
	                if (_c3 > 0) {
	                    if (_c3 != puzzle.rows[0][_j3].colour) return false; //look for first colour in row,
	                    break; //otherwise break out of this loop
	                }
	            }
	        } else {
	            var _j4 = cid - 3 * n;
	            if (puzzle.rows[n + 1][_j4].colour != -1) for (var _i7 = n; _i7 >= 1; _i7--) {
	                var _c4 = puzzle.rows[_i7][_j4].colour;
	                if (_c4 > 0) {
	                    if (_c4 != puzzle.rows[n + 1][_j4].colour) return false; //look for first colour in row,
	                    break; //otherwise break out of this loop
	                }
	            }
	        }
	    }
	    return true;
	};
	
	var puzzle = {
	    setSeed: function setSeed(seed) {
	        rand = rs.create(seed);
	    },
	
	    isSolution: isSolution,
	    generatePuzzle: generatePuzzleWithDifficulty,
	    generateFakePuzzle: function generateFakePuzzle() {
	        var size = 5;
	        var count = size + 2;
	
	        var startIdx = 0;
	        var endIdx = count - 1;
	
	        var genItem = function genItem(i, j) {
	            return {
	                x: j,
	                y: i,
	                interactive: true,
	                colour: 0,
	                answer: randomInt(4)
	            };
	        };
	
	        var genClue = function genClue(i, j) {
	            var answer = randomInt(4);
	            if (answer === 0) answer = -1;
	            return {
	                x: j,
	                y: i,
	                interactive: false,
	                colour: answer,
	                answer: answer
	            };
	        };
	
	        var rows = [];
	        for (var i = 0; i < count; i++) {
	            var row = [];
	            for (var j = 0; j < count; j++) {
	                if (i == startIdx && j == startIdx || i == endIdx && j == startIdx || j == endIdx && i == endIdx || j == endIdx && i == startIdx) {
	                    row.push({ x: i, y: j, interactive: false, colour: -1, answer: -1 });
	                } else if (i == startIdx || i == endIdx || j == startIdx || j == endIdx) {
	                    row.push(genClue(i, j));
	                } else {
	                    row.push(genItem(i, j));
	                }
	            }
	            rows.push(row);
	        }
	        return { rows: rows };
	    }
	};
	
	exports.default = puzzle;
	module.exports = exports["default"];

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _googleStoreImage = __webpack_require__(102);
	
	var _googleStoreImage2 = _interopRequireDefault(_googleStoreImage);
	
	var _iOSStoreImage = __webpack_require__(103);
	
	var _iOSStoreImage2 = _interopRequireDefault(_iOSStoreImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StoreLinks = function StoreLinks(_ref) {
	  var androidStoreLink = _ref.androidStoreLink,
	      iOSStoreLink = _ref.iOSStoreLink,
	      webLink = _ref.webLink,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'store-links' },
	    iOSStoreLink && _react2.default.createElement(
	      'a',
	      { href: iOSStoreLink },
	      _react2.default.createElement('img', { src: _iOSStoreImage2.default, alt: 'Download ' + title + ' from Apple App Store', style: { width: 135, height: 40 } })
	    ),
	    androidStoreLink && _react2.default.createElement(
	      'a',
	      { href: androidStoreLink },
	      _react2.default.createElement('img', { src: _googleStoreImage2.default, alt: 'Download ' + title + ' from Google Play', style: { width: 135, height: 40 } })
	    ),
	    webLink && _react2.default.createElement(
	      'a',
	      { href: webLink, alt: '' + title },
	      _react2.default.createElement(
	        'div',
	        { className: 'webLink' },
	        title.length < 16 ? title : "Web"
	      )
	    )
	  );
	};
	
	exports.default = StoreLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/googleStoreImage.7a60f99f.png";

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Game = __webpack_require__(29);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	var _storeLinks = __webpack_require__(64);
	
	var _storeLinks2 = _interopRequireDefault(_storeLinks);
	
	var _shareGame = __webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackGameSpec = {
	  seed: "fallback",
	  gridSize: 4,
	  colourCount: 3,
	  remove: 4,
	  title: "Sample RGB Logic Game"
	};
	
	var PlayPage = function (_React$Component) {
	  _inherits(PlayPage, _React$Component);
	
	  function PlayPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PlayPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      gameSpec: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PlayPage.prototype.componentDidMount = function componentDidMount() {
	    var gameSpec = (0, _shareGame.extractGameFromUrl)();
	    console.log(gameSpec);
	    if (gameSpec) {
	      this.setState({ gameSpec: gameSpec });
	    }
	  };
	
	  PlayPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Shared Game'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'This game of RGB Logic has been shared with you. Just tap or click on a square to change the colour. Tap again to go to next colour.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The fundamental rule of RGB logic is ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'You must place exactly one of each colour in every row and column'
	        ),
	        '. This holds for all puzzles (even the most complex).'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You must also match the clues on the outside. ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'The closest ',
	          _react2.default.createElement(
	            'em',
	            null,
	            'occupied'
	          ),
	          ' square to the outside clues must match the colour of the clue'
	        ),
	        '. You should match downwards from the top, rightwards from the left and so on.'
	      ),
	      this.state.gameSpec ? _react2.default.createElement(_Game2.default, this.state.gameSpec) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Invalid Link'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Sorry this link looks invalid. But here is a game of RGB Logic to try out.'
	        ),
	        _react2.default.createElement(_Game2.default, fallbackGameSpec)
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Download'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Get RGB Logic for iOS and Android. It is free and comes with new puzzles every day.'
	      ),
	      _react2.default.createElement(_storeLinks2.default, { androidStoreLink: 'https://play.google.com/store/apps/details?id=uk.amimetic.rgb.logic.pro&hl=en_GB',
	        iOSStoreLink: 'https://itunes.apple.com/gb/app/rgb-logic-buchstabensalat-logic-puzzles/id1097300530?mt=8' }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Share'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please let others know about RGB Logic. It is fun and free. And might make you smarter. Thanks.'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'http://www.facebook.com/sharer/sharer.php?u=https://rgb-logic.amimetic.co.uk',
	          alt: 'Share on Facebook' },
	        _react2.default.createElement(
	          'div',
	          { className: 'webLinkLarge' },
	          'Share on Facebook'
	        )
	      )
	    );
	  };
	
	  return PlayPage;
	}(_react2.default.Component);
	
	exports.default = PlayPage;
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var encodeState = exports.encodeState = function encodeState(state) {
	  try {
	    return window.btoa(JSON.stringify(state));
	  } catch (ex) {
	    return null;
	  }
	};
	
	var decodeState = exports.decodeState = function decodeState(encodedState) {
	  try {
	    return JSON.parse(window.atob(encodedState));
	  } catch (ex) {
	    return null;
	  }
	};
	
	var extractGameFromUrl = exports.extractGameFromUrl = function extractGameFromUrl() {
	  try {
	    var searchParams = new URLSearchParams(window.location.search);
	    return decodeState(searchParams.get("game"));
	  } catch (ex) {
	    return null;
	  }
	};
	
	var generateUrl = exports.generateUrl = function generateUrl(state, prefix) {
	  var encoded = encodeState(state);
	  return prefix + "?game=" + encoded;
	};
	
	var generateUrlForThisPage = exports.generateUrlForThisPage = function generateUrlForThisPage(state) {
	  try {
	    return generateUrl(state, window.location.origin + window.location.pathname);
	  } catch (ex) {
	    return "";
	  }
	};
	
	var twitterShare = exports.twitterShare = function twitterShare(message, url) {
	  return "http://twitter.com/share?text=" + encodeURI(message) + "&url=" + url;
	};
	
	var facebookShare = exports.facebookShare = function facebookShare(url) {
	  return "http://www.facebook.com/sharer/sharer.php?u=" + url;
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-play-js-33d8a230a86720060793.js